import * as React from 'react';
import Layout from 'shared/layouts/Main'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import hasAnyRole from 'shared/utils/hasAnyRole';
import { roles } from 'consts';
import LayoutSwitcher from 'components/LayoutSwitcher';
import { ReactReduxContext } from 'react-redux';

interface NotFoundProps {

}

const NotFound: React.FunctionComponent<NotFoundProps> = () => {


    const { store } = React.useContext(ReactReduxContext)

    return (
        <Layout
            footerContent={<Footer />}
            brandContent={getBrandContent()}
            pageTitle='404 Not Found'
            menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
        >
            <div style={{ height: '70vh' }}>
                <p>This page was not found.</p>
            </div>
        </Layout>
    );
}

export default NotFound